import { CustomerStatus, CustomerStatuses, Point, Sample } from '@/types';

export function getSamplePriceByPoint(sample: Sample | null, point: Point, customerStatus: CustomerStatus | null) {
  if (!sample?.customer_status_prices_for_points?.length)
    return CustomerStatuses.VIP ? sample?.vip_price : sample?.price;

  const price = sample?.customer_status_prices_for_points?.find((price) => price.point?.id === point.id);
  return customerStatus?.name === CustomerStatuses.VIP ? price?.vip_price : price?.common_price ?? 0;
}
